import type { Client } from "@/services/clientService";

/** Same rules as backend `deriveCfeTypeFromClient` for recurring invoice lines UI. */
export function deriveCfeTypeFromClientForRecurring(
  client: Client | undefined
): "101" | "111" | "121" {
  if (!client) return "111";
  const cc = client.countryCode?.trim().toUpperCase();
  if (cc && cc !== "UY") return "121";
  const rutDigits = (client.rut ?? "").replace(/\D/g, "");
  if (rutDigits.length >= 1) return "111";
  return "101";
}
